module.exports = __webpack_public_path__ + "img/marketing_img.cf9718b3.png";